import { message } from "antd";
import Api from './Api';
import axios from "axios";
import { BASE_API } from "./Api";
import { fetchExternalStates, fetchExternalDistricts, fetchExternalCities } from './ExternalApi';

const API_URL = BASE_API;

const API = Api;



export let accessToken = localStorage.getItem("access_token");
//////////////////////  WL /////////////////////////////////////////



export const UserRegPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await Api.post(
    "UserReg_wl/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const UserRegGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await Api.get(
    "UserReg_wl/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserRegUpdate = async (id, value) => {
  try {
    const response = await Api.put(`UserReg_wl/${id}/`, value, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("✅ UserRegUpdate success");
    return response?.data || [];
  } catch (error) {
    console.error("❌ UserRegUpdate error:", error.response?.data);
    throw error;
  }
}


export const VerifyOtp = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API_URL.post(
    "verify-otp/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

// ============================================
// 🕉️ RELIGION OPTIONS - FIXED
// ============================================
export const getReligionOptions = async () => {
  try {
    console.log("🔍 Fetching religions...");

    // ✅ Api instance use karo (axios direct nahi)
    const response = await Api.get("/api/religion-options/");

    console.log("✅ Religions API Response:", response.data);

    // ✅ Different response formats handle karo
    const data = response.data;

    // Format 1: { religions: [...] }
    if (data?.religions && Array.isArray(data.religions)) {
      return { religions: data.religions };
    }

    // Format 2: Direct array [...]
    if (Array.isArray(data)) {
      return { religions: data };
    }

    // Format 3: { data: [...] }
    if (data?.data && Array.isArray(data.data)) {
      return { religions: data.data };
    }

    // Format 4: { success: true, religions: [...] }
    if (data?.success && data?.religions) {
      return { religions: data.religions };
    }

    console.warn("⚠️ Unknown response format:", data);
    return { religions: [] };

  } catch (error) {
    console.error("❌ getReligionOptions Error:", error);
    console.error("❌ Status:", error.response?.status);
    console.error("❌ URL:", error.config?.url);
    console.error("❌ Data:", error.response?.data);

    // ✅ Empty return - component fallback use karega
    return { religions: [] };
  }
};

export const getAdminReligionOptions = async () => {
  const token = localStorage.getItem("access_token");
  const res = await axios.get(`${API_URL}/api/admin/religion-options/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const addReligionOption = async (data) => {
  const token = localStorage.getItem("access_token");
  const res = await axios.post(`${API_URL}/api/admin/religion-options/`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const updateReligionOption = async (id, data) => {
  const token = localStorage.getItem("access_token");
  const res = await axios.put(`${API_URL}/api/admin/religion-options/${id}/`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const toggleReligionOption = async (id) => {
  const token = localStorage.getItem("access_token");
  const res = await axios.patch(`${API_URL}/api/admin/religion-options/${id}/`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const deleteReligionOption = async (id) => {
  const token = localStorage.getItem("access_token");
  const res = await axios.delete(`${API_URL}/api/admin/religion-options/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};


// ============================================================
// ✅ GET - Sab profiles laane ke liye (With Token)
// ============================================================
export const UserDataGetwt = async () => {
  try {
    const accessToken = localStorage.getItem("access_token");

    const response = await API.get("UserDataReg_wl/", {
      headers: {
        "Content-Type": "application/json",
        // ✅ Token hai to bhejo, nahi hai to bhi call karo
        ...(accessToken && {
          Authorization: `Bearer ${accessToken}`,
        }),
      },
    });

    console.log("✅ UserDataGetwt response:", response.data);

    // ✅ Dono formats handle karo
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data?.profiles) {
      return response.data; // Pura object return karo
    }

    return [];
  } catch (error) {
    console.error("❌ GET error:", error.response?.data);
    return [];
  }
};

// ============================================================
// ✅ POST - Naya profile banao (No Token - Public)
// ============================================================
export const UserDataPostwt = async (values) => {
  try {
    const response = await API.post("UserDataReg_wl/", values, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("✅ POST success:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ POST error:", error.response?.data);
    throw error;
  }
};

// ============================================================
// ✅ PUT - Profile update karo
// ============================================================
export const UserDataPutwt = async (userId, values) => {
  try {
    const accessToken = localStorage.getItem("access_token");

    const response = await API.put(`UserDataReg_wl/${userId}/`, values, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("✅ PUT success:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ PUT error:", error.response?.data);
    throw error;
  }
};

// ============================================================
// ✅ DELETE - Profile delete karo
// ============================================================
export const UserDataDeletewt = async (userId) => {
  try {
    const accessToken = localStorage.getItem("access_token");

    const response = await API.delete(`UserDataReg_wl/${userId}/`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("✅ DELETE success");
    return response.data;

  } catch (error) {
    console.error("❌ DELETE error:", error.response?.data);
    throw error;
  }
};



export const getUserActivePlans = async () => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.get('api/user/plans/', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    return { plans: [], viewed_contacts: [], total_active: 0 };
  }
};

// ✅ Contact view permission check
export const checkContactPermission = async (targetUserId) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post(
      'api/check-contact/',
      { target_user_id: targetUserId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    return { can_view: false, message: 'Error checking permission' };
  }
};

// ✅ Boosted profiles
export const getBoostedProfiles = async () => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.get('api/boosted-profiles/', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    return { boosted_user_ids: [] };
  }
};
// ============================================
// ✅ USER DATA REMOVE WL (For UserPanel.jsx)
// ============================================
export const UserDataRemovewl = async (id) => {
  try {
    const token = localStorage.getItem('access_token');

    if (!id) {
      console.error("❌ No ID provided");
      message.error("Invalid ID");
      return null;
    }

    console.log("🗑️ Deleting UserDataReg_wl with ID:", id);

    // ✅ Try with trailing slash first
    let response;
    try {
      response = await API.delete(
        `UserDataReg_wl/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          }
        }
      );
    } catch (firstErr) {
      // ✅ Retry without trailing slash if 404
      if (firstErr.response?.status === 404) {
        console.log("🔄 Retrying without trailing slash...");
        response = await API.delete(
          `UserDataReg_wl/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            }
          }
        );
      } else {
        throw firstErr;
      }
    }

    console.log("✅ Deleted successfully");
    return response?.data || {};

  } catch (err) {
    console.error("❌ UserDataRemovewl error:", err);

    if (err.response) {
      if (err.response.status === 404) {
        message.error("Record not found");
      } else if (err.response.status === 401) {
        message.error("Please login again");
      } else {
        message.error("Failed to delete");
      }
    } else {
      message.error("Network error");
    }

    throw err;
  }
};

export const UserDataRemove = async (id) => {
  try {
    const token = localStorage.getItem('access_token');

    if (!id) {
      console.error("❌ No ID provided");
      message.error("Invalid ID");
      return null;
    }

    console.log("🗑️ Deleting UserData with ID:", id);

    const response = await API.delete(
      `UserData/${id}/`,   // ✅ Fixed: Use UserData endpoint with trailing slash
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        }
      }
    );

    console.log("✅ UserData deleted successfully");
    return response?.data || {};

  } catch (err) {
    console.error("❌ UserDataRemove error:", err);
    message.error("Failed to delete");
    throw err;
  }
};

export const UserImage_wt = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "UserImages_wl/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserPost = async (values) => {


  const response = await API.post(
    "UserRegister/",
    values,
    {
      headers: {
        "Content-Type": "application/json",  // ✅ JSON, not multipart
        Authorization: `Bearer ${accessToken}`,
      },
    }
  ).catch(
    (err) => {
      console.error("❌ UserPost error:", err);
      message.error("Registration Failed");
      throw err;
    }
  );
  console.log("✅ UserPost response:", response?.data);
  return response?.data || {};
};

// CoreApi.js - UserGet function
export const UserGet = async () => {
  try {

    const response = await API.get("UserRegister/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    // ✅ Debug: Check if ref field is coming
    console.log('📦 UserGet Response:', response.data);
    if (response.data && response.data.length > 0) {
      console.log('📦 First user:', response.data[0]);
      console.log('📦 First user ref:', response.data[0].ref);
      console.log('📦 First user profile_id:', response.data[0].profile_id);
    }

    return response.data || [];
  } catch (err) {
    console.error("❌ UserGet error:", err);
    message.error("Failed to fetch users");
    return [];
  }
};

export const UserUpdate = async (id, value) => {
  console.log("📤 UserUpdate called with:", { id, value });


  try {
    const response = await API.put(
      `UserRegister/${id}/`,
      value,
      {
        headers: {
          "Content-Type": "application/json",  // ✅ Use JSON, not multipart
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
    console.log("✅ UserUpdate response:", response.data);
    return response?.data || [];
  } catch (err) {
    console.error("❌ UserUpdate error:", err);
    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);
    }
    message.error("Update failed");
    throw err;
  }
};

export const User_Array_Update = async (id, value) => {
  // for array of object //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `UserRegister/${id}/`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserRemove = async (id) => {
  try {


    if (!id) {
      console.error("❌ No ID provided");
      message.error("Invalid user ID");
      return null;
    }

    console.log("🗑️ Deleting user with ID:", id);

    // ✅ Try with trailing slash first
    let response;
    try {
      response = await API.delete(
        `UserRegister/${id}/`,   // ✅ With trailing slash
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          }
        }
      );
    } catch (firstErr) {
      // ✅ If 404, try without trailing slash
      if (firstErr.response?.status === 404) {
        console.log("🔄 Retrying without trailing slash...");
        response = await API.delete(
          `UserRegister/${id}/`,   // ✅ Without trailing slash
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            }
          }
        );
      } else {
        throw firstErr;
      }
    }

    console.log("✅ Delete successful:", response.data);
    return response?.data || {};

  } catch (err) {
    console.error("❌ UserRemove error:", err);

    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);

      if (err.response.status === 404) {
        message.error("User not found");
      } else if (err.response.status === 401) {
        message.error("Please login again");
      } else if (err.response.status === 403) {
        message.error("You don't have permission");
      } else if (err.response.status === 405) {
        message.error("Method not allowed - Check backend URL");
      } else {
        message.error(err.response.data?.error || "Failed to delete user");
      }
    } else {
      message.error("Network error");
    }

    throw err;
  }
};

// Login////
export const UserLogin = async (values) => {
  try {
    const response = await API.post("UserLogin/", values, {
      headers: { "Content-Type": "application/json" }
    });

    // ✅ Existing code same rakho
    localStorage.removeItem('user_gender');
    localStorage.removeItem('user_caste');
    localStorage.removeItem('cached_user_id');

    if (response.data?.token) {
      localStorage.setItem('access_token', response.data.token.access);
      localStorage.setItem('refresh_token', response.data.token.refresh);
      accessToken = response.data.token.access; 
    }

    if (response.data?.user_id) {
      localStorage.setItem('user_id', response.data.user_id);
      localStorage.setItem('username', response.data.username || '');
      localStorage.setItem('role', response.data.role || 'user');
      localStorage.setItem('refer', response.data.refer || '');
    }

    if (response.data?.gender) {
      localStorage.setItem('user_gender', response.data.gender);
    }

    if (response.data?.caste) {
      localStorage.setItem('user_caste', response.data.caste);
    }

    if (response.data?.user_id) {
      localStorage.setItem('cached_user_id', response.data.user_id);
    }

    // ✅ YE NEW CODE ADD KARO - Last Login localStorage me save karo
    if (response.data?.last_login) {
      localStorage.setItem('last_login', response.data.last_login);
    } else if (response.data?.is_first_login) {
      localStorage.setItem('last_login', 'First Login 🎉');
    } else {
      localStorage.setItem('last_login', 'N/A');
    }

    return response.data;

  } catch (error) {
    console.error("❌ Login Error:", error);
    throw error;
  }
};

export const User_forget_password = async (values) => {
  console.log("📧 Forget password:", values);

  try {
    // ✅ axios directly use करो - Api instance नहीं
    const response = await axios.post(
      `${BASE_API}/send-email/`,  // ← Full URL
      values,
      {
        headers: {
          "Content-Type": "application/json",
          // ✅ Authorization नहीं - public endpoint
        }
      }
    );

    console.log("✅ Email sent:", response.data);
    return response.data;

  } catch (err) {
    console.error("❌ Error:", err.response?.data);

    // ✅ Backend का error message throw करो
    const errMsg = err.response?.data?.error
      || "Failed to send email";
    throw new Error(errMsg);
  }
};

export const User_send_otp = async (values) => {
  console.log("📤 Sending OTP:", values);
  try {
    const response = await API.post("send-phone-otp/", values, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("✅ OTP Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ OTP Error:", error);

    // ✅ Check if error is because mobile already registered
    if (error.response?.status === 400 && error.response?.data?.already_registered) {
      // ✅ Throw with already_registered flag
      throw {
        ...error,
        already_registered: true,
        message: error.response.data.error || 'This mobile number is already registered',
        user_id: error.response.data.user_id,
        username: error.response.data.username,
      };
    }
    throw error;
  }
};

export const User_verify_otp = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(values);
  const response = await API.post(
    "verify-phone-otp/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const User_verify_WO = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(values);
  const response = await API.post(
    "verify-phone-WO/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};


////////////////////////////////// UserData ///////////////////////////////////////////

export const UserDataPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "UserData/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};
// ✅ KEEP THIS - WITH ACCESS TOKEN IN HEADERS
export const UserDataGet = async () => {
  try {
    console.log("📤 UserDataGet: Fetching...");

    // ⭐ API instance use karo - interceptor auto token add karega
    const response = await API.get("UserDataReg_wl/");

    console.log("📦 UserDataGet Raw Response:", response?.data);

    // ⭐ Extract array from any format
    let users = [];
    
    if (Array.isArray(response?.data)) {
      users = response.data;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
      users = response.data.data;
    } else if (response?.data?.results && Array.isArray(response.data.results)) {
      users = response.data.results;
    } else if (response?.data?.users && Array.isArray(response.data.users)) {
      users = response.data.users;
    } else if (typeof response?.data === 'object' && response.data !== null) {
      // Try to find any array in object
      const arrayValue = Object.values(response.data).find(v => Array.isArray(v));
      if (arrayValue) users = arrayValue;
    }

    console.log(`✅ UserDataGet Success: ${users.length} profiles`);

    // ✅ Safe map - only if array
    if (users.length === 0) {
      console.warn("⚠️ No users found in response");
      return [];
    }

    return users.map(user => ({
      ...user,
      profileId: user.profile_id ? `CR${user.profile_id}` : 'N/A',
      ref: user.ref || user.profile_id || '',
    }));

  } catch (error) {
    console.error("❌ UserDataGet Error:", error);
    return [];
  }
};

export const UserDataUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `UserData/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserData_Array_Update = async (id, value) => {
  // for array of object //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `UserData/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserImagesPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "UserImages/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const UserImagesGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "UserImages/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserImagesUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `UserImages/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserImagesRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `UserImages/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};



export const PostChargesPost = async (data) => {
  try {
    const res = await API.post('PostCharges/', data);  // ✅ / at end
    return res.data;
  } catch (err) {
    console.error("Post error:", err);
    throw err;
  }
};

export const PostChargesGet = async () => {
  try {
    const res = await API.get('PostCharges/');  // ✅ / at end
    return res.data;
  } catch (err) {
    console.error("Get error:", err);
    return [];
  }
};

// ⭐ Get single commission
export const PostChargesGetOne = async (id) => {
  try {
    const res = await API.get(`PostCharges/${id}/`);  // ✅ / at end
    return res.data;
  } catch (err) {
    console.error("Get one error:", err);
    throw err;
  }
};

export const PostChargesUpdate = async (id, data) => {
  try {
    console.log(`✏️ Updating commission ID: ${id}`);
    const res = await API.put(`PostCharges/${id}/`, data);  // ✅ / at end
    console.log("✅ Update success");
    return res.data;
  } catch (err) {
    console.error("❌ Update error:", err.response?.status, err.response?.data);
    throw err;
  }
};

// ✅ CORRECT:
export const PostChargesRemove = async (id) => {
  try {
    console.log(`🗑️ Deleting commission ID: ${id}`);
    const res = await API.delete(`PostCharges/${id}/`);  // ⭐⭐⭐ / at end!
    console.log("✅ Delete success:", res.data);
    return res.data;
  } catch (err) {
    console.error("❌ Delete error:", err.response?.status, err.response?.data);
    throw err;
  }
};

/////////////////////////////// UserTotalRevenue /////////////////////////////////////////////

export const UserTotalRevenuePost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "UserTotalRevenue/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const UserTotalRevenueGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "UserTotalRevenue/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserTotalRevenueUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `UserTotalRevenue/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserTotalRevenueRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `UserTotalRevenue/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

/////////////////////////////// AdminTotalRevenue /////////////////////////////////////////////

export const AdminTotalRevenuePost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "AdminTotalRevenue/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const AdminTotalRevenueGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "AdminTotalRevenue/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const AdminTotalRevenueUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `AdminTotalRevenue/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const AdminTotalRevenueRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `AdminTotalRevenue/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

/////////////////////////////// StaffTotalRevenue /////////////////////////////////////////////

export const StaffTotalRevenuePost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "StaffTotalRevenue/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const StaffTotalRevenueGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "StaffTotalRevenue/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const StaffTotalRevenueUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `StaffTotalRevenue/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const StaffTotalRevenueRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `StaffTotalRevenue/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

/////////////////////////////// DevTotalRevenue /////////////////////////////////////////////

export const DevTotalRevenuePost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "DevTotalRevenue/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const DevTotalRevenueGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "DevTotalRevenue/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const DevTotalRevenueUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `DevTotalRevenue/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const DevTotalRevenueRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `DevTotalRevenue/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};
/////////////////////////////// StaffTransactions /////////////////////////////////////////////

export const StaffTransactionsPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "StaffTransactions/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const StaffTransactionsGet = async () => {


  if (!accessToken) {
    console.error("No token found!");
    return [];
  }

  const response = await API.get("StaffTransactions/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    }
  }).catch((err) => {
    console.error("StaffTransactions Error:", err.response?.data);
    message.error("Failed to fetch staff transactions");
    return null;
  });

  return response?.data || [];
};

export const StaffTransactionsUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `StaffTransactions/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const StaffTransactionsRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `StaffTransactions/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};


/////////////////////////////// UserTransactions /////////////////////////////////////////////

export const UserTransactionsPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "UserTransactions/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

// CoreApi.jsx - UserTransactionsGet mein debug add karo

export const UserTransactionsGet = async (...args) => {
  console.log("🔍 UserTransactionsGet called with:", args);  // ✅ ADD
  console.log("🔍 Arguments length:", args.length);



  if (!accessToken) {
    console.error("No token found!");
    return [];
  }

  const response = await API.get("UserTransactions/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    }
  }).catch((err) => {
    console.error("UserTransactions Error:", err.response?.data);
    return null;
  });

  return response?.data || [];
};

export const UserTransactionsUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `UserTransactions/${id}/`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const UserTransactionsRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `UserTransactions/${id}/`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};
// ✅ Delete function
export const UserTransactionsDelete = async (id) => {
  try {
    console.log(`🗑️ Deleting transaction #${id}`);
    const response = await API.delete(`UserTransactions/${id}/`);
    console.log("✅ Deleted:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Delete error:", err?.response?.data);
    throw err;
  }
};



/////////////////////////////// DevTransactions /////////////////////////////////////////////

export const DevTransactionsPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "DevTransactions/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};


export const StaffTransactionsFilteredGet = async () => {
  try {


    if (!accessToken) {
      console.warn("⚠️ No access token found");
      return { transactions: [], user_transactions: [], staff_transactions: [], total: 0, referred_users_count: 0 };
    }

    console.log("📤 Fetching staff filtered transactions...");

    const response = await API.get("staff-transactions/filtered/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    console.log("✅ Staff Filtered Transactions Response:", response.data);
    return response.data || { transactions: [], user_transactions: [], staff_transactions: [], total: 0, referred_users_count: 0 };

  } catch (error) {
    console.error("❌ StaffTransactionsFilteredGet Error:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
    }
    return { transactions: [], user_transactions: [], staff_transactions: [], total: 0, referred_users_count: 0 };
  }
};

export const DevTransactionsGet = async () => {


  if (!accessToken) {
    console.error("No token found!");
    return [];
  }

  const response = await API.get("DevTransactions/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    }
  }).catch((err) => {
    console.error("DevTransactions Error:", err.response?.data);
    message.error("Failed to fetch dev transactions");
    return null;
  });

  return response?.data || [];
};

export const DevTransactionsUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `DevTransactions/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const DevTransactionsRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `DevTransactions/${id}/`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};


// ///////////////////////// USER STATE ////////////////////

export const User_StatePost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "state/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const User_StateGet = async () => {
  try {
    // ✅ Try external API first with country code 'IN'
    const externalStates = await fetchExternalStates('IN');
    if (externalStates && externalStates.length > 0) {
      console.log(`✅ Loaded ${externalStates.length} states from external API`);
      // Transform to match your format
      return externalStates.map(state => ({
        state: state.name,      // API se 'name' field mein state ka naam
        iso2: state.iso2,       // State code (UP, MH, etc.)
        id: state.id,
      }));
    }
  } catch (error) {
    console.warn('⚠️ External API failed, falling back to local:', error.message);
  }

  // ✅ Fallback to your local API
  try {
    const response = await axios.get(`${API_URL}/state/`);
    return response.data;
  } catch (error) {
    console.error('❌ Both external and local APIs failed:', error);
    return [];
  }
};
export const User_StateUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `state/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const User_StateRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `state/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

// ///////////////////////// USER CASTE ////////////////////

export const User_CastePost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "caste/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const User_CasteGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "caste/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const User_CasteUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `caste/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const User_CasteRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `caste/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};





// Chatbot core api 




//  Contact form  home pages 

// ///////////////////////// USER Contact ////////////////////

export const User_ContactPost = async (values) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  // console.log(values)
  const response = await API.post(
    "contactdetails/",
    values, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("Registration Failed")
  );
  console.log(values);
  return response?.data || [];
};

export const User_ContactGet = async () => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  const response = await API.get(
    "contactdetails/", // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const User_ContactUpdate = async (id, value) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(value, "***** value ***** ");
  const response = await API.put(
    `contactdetails/${id}`,
    value, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const User_ContactRemove = async (id) => {
  //empLogin -- function name , async -- wait for time , (value)-- form data varriable send by EmpLogin function
  console.log(id, "********* delete **********");
  const response = await API.delete(
    `contactdetails/${id}`, // await - wait , Api - component (promise) , post - define a operation, api/Reg - backend Post path , value - parameter to  send data
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).catch(
    // handler - backend url
    (err) => message.error("getdata Failed")
  );
  return response?.data || [];
};

export const checkEmailAvailability = async (email) => {
  try {
    if (!email || !email.trim()) {
      return { available: true };
    }

    const encodedEmail = encodeURIComponent(email.trim().toLowerCase());
    const response = await API.get(
      `api/check-email/${encodedEmail}/`
    );
    return response.data;

  } catch (error) {
    console.error('Email check error:', error);
    // ✅ Error pe block mat karo
    return { available: true };
  }
};

// ============================================
// SUCCESS STORIES — 
// ============================================

export const User_SuccessStoriesGet = async () => {
  try {
    const token = localStorage.getItem('access_token') || localStorage.getItem('token');
    
   
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

   
    const response = await API.get('successstories/', { headers });

    return response.data;
  } catch (err) {
    console.error('Stories Fetch Error:', err.response?.status, err.message);
    
   
    if (err.response?.status === 401 && localStorage.getItem('access_token')) {
     
    }
    
    return [];
  }
};

export const User_SuccessStoriesPost = async (formData) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post('successstories/', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('✅ Story created:', response.data);
    return response.data;
  } catch (err) {
    console.log('❌ Error:', err.response?.data);
    throw err;
  }
};

export const User_SuccessStoriesUpdate = async (id, formData) => {
  try {
    const token = localStorage.getItem('access_token');
    console.log(`📤 Updating story ID: ${id}`);
    const response = await API.put(`successstories/${id}/`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('✅ Update response:', response.data);
    return response.data;
  } catch (err) {
    console.error('❌ Update error:', err.response?.status, err.response?.data);
    throw err;
  }
};

export const User_SuccessStoriesRemove = async (id) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.delete(`successstories/${id}/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};
// ============================================
// ✅ NEW - User/Staff ke liye
// ============================================

// Apni stories fetch karo
export const getMySuccessStories = async () => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.get('my-stories/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // backend kabhi array, kabhi { data: [] }
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.results)) return data.results;
    return [];
  } catch (err) {
    console.error('getMySuccessStories:', err.response?.status, err.message);
    throw err;
  }
};

// Story submit karo
export const submitSuccessStory = async (formData) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post('my-stories/', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (err) {
    console.error('submitSuccessStory:', err.response?.data);
    throw err;
  }
};

// Story delete karo
export const deleteMyStory = async (id) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.delete(`my-stories/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error('deleteMyStory:', err.response?.data);
    throw err;
  }
};



// ✅ NAYA - API aur access_token use karo (same pattern as baaki functions)
export const getUserReferralInfo = async (userId) => {
  try {


    if (!accessToken) {
      console.warn("⚠️ No access token found");
      return null;
    }

    if (!userId) {
      console.warn("⚠️ No userId provided");
      return null;
    }

    console.log("🎁 Fetching referral info for:", userId);

    const response = await API.get(`api/user-referral/${userId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("✅ Referral Info:", response.data);
    return response.data || null;

  } catch (error) {
    console.error("❌ Error fetching referral info:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
    }
    return null;
  }
};

// ============================================
// ✅ NEW - Admin Approve/Reject
// ============================================

export const getAllStoriesAdmin = async (status = null) => {
  try {
    const token = localStorage.getItem('access_token');
    const url = status && status !== 'all'
      ? `story-review/?status=${status}`
      : 'story-review/';
    const response = await API.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    return { stories: [], stats: {} };
  }
};


export const updateMyStory = async (id, formData) => {
  try {
    const token = localStorage.getItem('access_token');
    console.log(`📤 Updating my story ID: ${id}`);
    const response = await API.put(`my-stories/${id}/`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('✅ My story updated:', response.data);
    return response.data;
  } catch (err) {
    console.error(
      '❌ updateMyStory:',
      err.response?.status,
      err.response?.data
    );
    throw err;
  }
};

// ✅ adminDeleteStory
export const adminDeleteStory = async (id) => {
  try {
    const token = localStorage.getItem('access_token');
    await API.delete(`story-review/${id}/`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return true;
  } catch (err) {
    throw err;
  }
};

// ✅ Public - Landing page
export const getPublicSuccessStories = async () => {
  try {
    const response = await API.get('successstories/');
    return response.data || [];
  } catch (err) {
    return [];
  }
};
// ============================================
// Admin — Approve / Reject (Admin Panel)
// ============================================
export const updateStoryStatus = async (id, status, admin_note = '') => {
  try {
    const token = localStorage.getItem('access_token');
    console.log(`📤 Story status → ${status} | ID: ${id}`);

    const response = await API.patch(
      `story-review/${id}/`,
      {
        status,           // 'approved' | 'rejected' | 'pending'
        admin_note: admin_note || '',
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log('✅ Story status updated:', response.data);
    return response.data;
  } catch (err) {
    console.error(
      '❌ updateStoryStatus:',
      err.response?.status,
      err.response?.data
    );
    throw err;
  }
};








// Make sure `API`, `message`, and `accessToken` are defined/imported in this file.

export const RechargePlanPost = async (values) => {
  try {
    const response = await API.post(
      "RechargePlan/",
      values,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    console.log(values);
    return response.data;
  } catch (err) {
    message.error("Registration failed");
    return {};
  }
};

export const RechargePlanGet = async () => {
  try {
    const response = await API.get(
      "RechargePlan/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    message.error("Get data failed");
    return {};
  }
};


export const RechargePlanUpdate = async (id, value) => {
  console.log(value, "***** value *****");
  try {
    const response = await API.put(
      `RechargePlan/${id}`,
      value,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    message.error("Update failed");
    return {};
  }
};

export const RechargePlanRemove = async (id) => {
  console.log(id, "********* delete **********");
  try {
    const response = await API.delete(
      `RechargePlan/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    message.error("Delete failed");
    return {};
  }
};






// CoreApi.jsx - Fix ShortlistedGet
// CoreApi.jsx - Fix ShortlistedGet
export const ShortlistedGet = async () => {
  try {

    console.log("🔑 ShortlistedGet - Token:", accessToken ? "Present" : "Missing");

    // ✅ Try both endpoints
    let response;
    try {
      response = await API.get("shortlist/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      });
    } catch (err) {
      console.log("⚠️ shortlist/ failed, trying shortlist-data/");
      response = await API.get("shortlist-data/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      });
    }

    console.log("📦 ShortlistedGet Response:", response);

    let data = response.data || [];

    // ✅ Handle different response formats
    if (data && data.data) {
      data = data.data;
    }
    if (data && data.results) {
      data = data.results;
    }
    if (!Array.isArray(data)) {
      data = Object.values(data || {});
    }

    console.log("📦 Processed Data:", data);
    return data;
  } catch (err) {
    console.error("❌ ShortlistedGet Error:", err);
    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);
    }
    return [];
  }
};
// Delete shortlisted profile
// CoreApi.jsx - Fix ShortlistedRemove

export const ShortlistedRemove = async (id) => {
  try {


    if (!id) {
      console.error("❌ No shortlist ID provided");
      message.error("Invalid shortlist ID");
      return {};
    }

    console.log("🗑️ Removing shortlist with ID:", id);

    // ✅ Try multiple endpoints with correct format
    const endpoints = [
      `shortlist/${id}/`,        // ✅ Primary endpoint
      `shortlist-data/${id}/`,   // ✅ Alternative endpoint
    ];

    let lastError = null;

    for (const endpoint of endpoints) {
      try {
        console.log(`📤 Trying DELETE: ${endpoint}`);
        const response = await API.delete(endpoint, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        console.log(`✅ Successfully removed from: ${endpoint}`, response.data);
        return response.data || {};
      } catch (err) {
        lastError = err;
        console.warn(`❌ Failed with endpoint: ${endpoint}`, err.response?.status);
        if (err.response?.status === 404) {
          // ✅ If 404, try next endpoint
          continue;
        }
        // ✅ If other error, break
        break;
      }
    }

    // ✅ If all fail, show error but consider it done (maybe already deleted)
    if (lastError?.response?.status === 404) {
      console.warn("⚠️ Record already deleted or not found");
      return { already_deleted: true };
    }

    throw lastError || new Error("Failed to remove from shortlist");

  } catch (error) {
    console.error("❌ Error removing from shortlist:", error);

    if (error.response?.status === 404) {
      // ✅ If not found, consider it already removed
      message.success("✅ Already removed from shortlist");
      return { already_deleted: true };
    } else if (error.response?.status === 401) {
      message.error("Please login again");
    } else {
      message.error("Failed to remove from shortlist");
    }
    return {};
  }
};

//////////////////// REQUEST API ////////////////////

// Get all requests
export const RequestGet = async () => {
  try {


    if (!accessToken) {
      console.error("❌ No access token found");
      return [];
    }

    console.log("📤 Fetching requests...");

    const response = await API.get("requests/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      }
    });

    console.log("📥 Requests Response:", response.data);

    // ✅ Ensure data is array
    let data = response.data || [];
    if (!Array.isArray(data)) {
      data = [];
    }

    return data;

  } catch (err) {
    console.error("❌ RequestGet Error:", err);
    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);
    }
    return [];
  }
};

// ✅ Fix RequestUpdate
export const RequestUpdate = async (id, values) => {
  try {


    console.log(`📤 Updating request ${id}:`, values);

    const response = await API.put(
      `requests/${id}/`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        }
      }
    );

    console.log("📥 Update Response:", response.data);
    return response?.data || {};

  } catch (err) {
    console.error("❌ RequestUpdate Error:", err);
    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);
    }
    throw err;
  }
};

// ✅ Fix RequestDelete
export const RequestDelete = async (id) => {
  try {


    console.log(`🗑️ Deleting request ${id}`);

    const response = await API.delete(
      `requests/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        }
      }
    );

    console.log("✅ Delete Response:", response.data);
    return response?.data || {};

  } catch (err) {
    console.error("❌ RequestDelete Error:", err);
    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);
    }
    throw err;
  }
};

// src/services/CoreApi.jsx

// ============================================
// ALL USERS APIs - Fixed
// ============================================






/// src/Api/CoreApi.jsx - Fix Shortlist Functions

/**
 * Get Shortlisted Users - UPDATED
 * @returns {Promise<Array>} Shortlisted users list
 */
export const getShortlistedUsers = async () => {
  try {


    if (!accessToken) {
      console.warn("⚠️ No access token found");
      return [];
    }

    // ✅ ONLY use shortlist/ endpoint
    const response = await API.get("shortlist/", {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    console.log("✅ Shortlist data:", response.data);

    let data = response.data;
    if (data && data.data) {
      data = data.data;
    }
    if (data && data.results) {
      data = data.results;
    }
    if (!Array.isArray(data)) {
      data = Object.values(data || {});
    }

    return data;
  } catch (err) {
    console.error("❌ Error fetching shortlist:", err);
    return [];
  }
};







/**
 * Get Connection Requests
 * @returns {Promise<Array>} List of connection requests
 */
export const getConnectionRequests = async () => {
  try {

    const response = await API.get("requests/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data || [];
  } catch (err) {
    console.error("Error fetching connection requests:", err);
    return [];
  }
};

/**
 * Update Connection Request Status
 * @param {string|number} requestId - Request ID
 * @param {string} status - 'accepted' or 'rejected'
 * @returns {Promise<Object>} Response
 */
export const updateRequestStatus = async (requestId, status) => {
  try {

    const response = await API.patch(
      `requests/${requestId}/`,
      { status: status },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    message.success(`Request ${status}!`);
    return response.data || {};
  } catch (err) {
    console.error("Error updating request status:", err);
    message.error("Failed to update request");
    return {};
  }
};

// ============================================
// ALL USERS APIs
// ============================================

// src/Api/CoreApi.jsx - Fix getAllUsersList

export const getAllUsersList = async () => {
  try {

    const response = await API.get("UserData/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("All Users Raw Response:", response);

    let userList = [];

    // ✅ Handle response - backend returns array directly
    if (Array.isArray(response.data)) {
      userList = response.data;
    } else if (response.data && response.data.results) {
      userList = response.data.results;
    } else if (response.data && response.data.user) {
      // Single user response
      userList = [response.data.user];
    } else if (Array.isArray(response)) {
      userList = response;
    } else {
      userList = Object.values(response.data || {});
    }

    // ✅ Filter out invalid users
    userList = userList.filter(user => user && (user.id || user.user_id || user.user));

    console.log("✅ Processed Users:", userList.length);
    return userList;
  } catch (err) {
    console.error("Error fetching all users:", err);
    message.error("Failed to load users");
    return [];
  }
};

// src/Api/CoreApi.jsx - Updated getAllUsers

export const getAllUsers = async () => {
  try {

    const response = await API.get("UserData/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("All Users Response:", response);

    // Handle different response formats
    let userList = [];
    if (Array.isArray(response.data)) {
      userList = response.data;
    } else if (response.data && response.data.results) {
      userList = response.data.results;
    } else if (response.data && response.data.user) {
      userList = [response.data.user];
    } else if (Array.isArray(response)) {
      userList = response;
    } else {
      userList = Object.values(response.data || {});
    }

    // ✅ Sirf 'user' role walo ko filter karein
    userList = userList.filter(user =>
      user && typeof user === 'object' &&
      user.role === 'user'  // ✅ Sirf user role
    );

    return userList;
  } catch (err) {
    console.error("Error fetching all users:", err);
    message.error("Failed to load users");
    return [];
  }
};

// src/Api/CoreApi.jsx - REPLACE getPublicUserProfile

/**
 * Get Public User Profile - COMPLETE FIX
 * @param {string|number} userId - User ID
 * @returns {Promise<Object>} User profile data
 */
export const getPublicUserProfile = async (userId) => {
  try {


    if (!userId) {
      console.error("❌ No userId provided");
      return null;
    }

    console.log("🔍 Fetching user profile for ID:", userId);

    // ✅ ONLY use api/user/profile/ - yeh UUID handle karta hai
    try {
      const response = await API.get(`api/user/profile/${userId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      console.log("📦 Profile endpoint response:", response.data);

      if (response.data) {
        const data = response.data;
        return {
          id: data.user_id || data.id || userId,
          user_id: data.user_id || data.id || userId,
          profile_id: data.profile_id || data.bid || '',
          username: data.username || '',
          firstname: data.firstname || data.first_name || data.name || 'User',
          gender: data.gender || '',
          age: data.age || 0,
          dob: data.dob || '',
          height: data.height || '',
          weight: data.weight || '',
          nationality: data.nationality || '',
          religion: data.religion || '',
          caste: data.caste || '',
          subcaste: data.subcaste || '',
          mother_tongue: data.motherTongue || data.mother_tongue || '',
          languages: data.languages || [],
          marrige_status: data.marrige_status || data.maritalstatus || '',
          blood_group: data.blood_group || '',
          district: data.district || '',
          state: data.state || '',
          city: data.city || '',
          country: data.country || 'India',
          email: data.email || '',
          contact: data.contact || '',
          contact1: data.contact1 || '',
          smoking: data.smoking || '',
          drinking: data.drinking || '',
          bio: data.bio || data.about || '',
          hobbies: data.hobbies || [],
          interests: data.interests || [],
          father_name: data.father_name || data.father || '',
          mother_name: data.mother_name || data.mother || '',
          father_occupation: data.father_occupation || '',
          mother_occupation: data.mother_occupation || '',
          brother: data.brother || 0,
          sister: data.sister || 0,
          brother_marrige: data.brother_marrige || 0,
          sister_marrige: data.sister_marrige || 0,
          about_family: data.about_family || data.aboutFamily || '',
          university: data.university || '',
          course: data.course || data.education || '',
          sub_course: data.sub_course || '',
          job_title: data.job_title || data.occupation || '',
          job_type: data.job_type || '',
          company: data.company || '',
          annual_income: data.annual_income || data.income || 0,
          Lifestyle: data.Lifestyle || data.lifestyle || '',
          created_profile: data.created_profile || '',
          additional_notes: data.additional_notes || '',
          height_preference: data.height_preference || '',
          age_preference: data.age_preference || '',
          education_preference: data.education_preference || '',
          religion_preference: data.religion_preference || '',
          location_preference: data.location_preference || '',
          is_online: data.is_online || data.online || false,
          verified: data.verified || false,
          premium: data.premium || false,
          image: data.image || data.pic || '',
          pic: data.pic || data.image || '',
          location: data.location || (data.city && data.state ? `${data.city}, ${data.state}` : data.city || data.state || ''),
        };
      }
    } catch (err) {
      console.log("❌ Profile endpoint failed:", err.response?.status);
      if (err.response?.status === 404) {
        console.log("User not found with UUID:", userId);
        return null;
      }
    }

    console.error("❌ All endpoints failed for user:", userId);
    return null;

  } catch (error) {
    console.error("❌ Error fetching user profile:", error);
    return null;
  }
};

// ============================================================
// HELPER FUNCTION - Map UserData to consistent format
// ============================================================

const mapUserData = (data, userId) => {
  return {
    id: data.id || data.user_id || data.User_id || userId,
    user_id: data.user_id || data.id || data.User_id || userId,
    profile_id: data.profile_id || '',
    username: data.username || '',
    firstname: data.firstname || data.first_name || data.name || '',
    gender: data.gender || '',
    age: data.age !== null && data.age !== undefined ? data.age : 0,
    dob: data.dob || '',
    height: data.height || '',
    weight: data.weight || '',
    nationality: data.nationality || '',
    religion: data.religion || '',
    caste: data.caste || '',
    subcaste: data.subcaste || '',
    gotra: data.gotra || '',
    mother_tongue: data.mother_tongue || '',
    languages: data.languages || [],
    marrige_status: data.marrige_status || data.maritalstatus || '',
    city: data.city || '',
    state: data.state || '',
    district: data.district || '',
    country: data.country || 'India',
    diet: data.diet || '',
    smoking: data.smoking || '',
    drinking: data.drinking || '',
    bio: data.bio || data.about || '',
    hobbies: data.hobbies || [],
    interests: data.interests || [],
    family_status: data.family_status || data.familyStatus || '',
    family_type: data.family_type || data.familyType || '',
    family_values: data.family_values || data.familyValues || '',
    father_name: data.father_name || data.father || '',
    mother_name: data.mother_name || data.mother || '',
    father_occupation: data.father_occupation || '',
    mother_occupation: data.mother_occupation || '',
    brother: data.brother !== null && data.brother !== undefined ? data.brother : 0,
    brother_marrige: data.brother_marrige !== null && data.brother_marrige !== undefined ? data.brother_marrige : 0,
    sister: data.sister !== null && data.sister !== undefined ? data.sister : 0,
    sister_marrige: data.sister_marrige !== null && data.sister_marrige !== undefined ? data.sister_marrige : 0,
    occupation_in_family: data.occupation_in_family || data.occupationInFamily || '',
    education_in_family: data.education_in_family || data.educationInFamily || '',
    about_family: data.about_family || data.aboutFamily || '',
    course: data.course || data.education || '',
    university: data.university || '',
    sub_course: data.sub_course || '',
    job_title: data.job_title || data.occupation || '',
    job_type: data.job_type || '',
    company: data.company || '',
    annual_income: data.annual_income !== null && data.annual_income !== undefined ? data.annual_income : 0,
    created_profile: data.created_profile || '',
    pic: data.pic || data.image || '',
    cover_img: data.cover_img || '',
    email: data.email || '',
    contact: data.contact || '',
    contact1: data.contact1 || '',
    is_online: data.is_online || data.online || false,
    verified: data.verified || false,
    premium: data.premium || false,
    height_preference: data.height_preference || data.heightPreference || '',
    age_preference: data.age_preference || data.agePreference || '',
    education_preference: data.education_preference || data.educationPreference || '',
    religion_preference: data.religion_preference || data.religionPreference || '',
    location_preference: data.location_preference || data.locationPreference || '',
    create_date: data.create_date || data.memberSince || '',
    profile_completion: data.profile_completion || 0,
    blood_group: data.blood_group || '',
    ref: data.ref || '',
    additional_notes: data.additional_notes || '',
    Lifestyle: data.Lifestyle || '',
  };
};

// ============================================
// BIODATA MATCHES API
// ============================================

/**
 * Get Biodata Matches
 * @returns {Promise<Array>} List of matches
 */
export const getBiodataMatches = async () => {
  try {

    const response = await API.get("user/dashboard/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data || {};
  } catch (err) {
    console.error("Error fetching biodata matches:", err);
    message.error("Failed to load matches");
    return {};
  }
};

// Get own profile (works for any role)
export const MyProfileGet = async () => {
  try {

    const response = await API.get("my-profile/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("❌ MyProfileGet error:", err);
    return null;
  }
};

// Update own profile
export const MyProfileUpdate = async (data) => {
  try {

    const response = await API.put("my-profile/", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("❌ MyProfileUpdate error:", err);
    throw err;
  }
};
// ============================================
// DASHBOARD API
// ============================================

/**
 * Get User Dashboard Data
 * @returns {Promise<Object>} Dashboard data
 */
export const getUserDashboard = async () => {
  try {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.error("❌ No access token found");
      message.error("Please login first");
      return {};
    }

    console.log("📊 Fetching dashboard with token:", accessToken);

    const response = await API.get("user/dashboard/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("✅ Dashboard Response:", response.data);
    return response.data || {};

  } catch (err) {
    console.error("❌ Error fetching dashboard:", err);
    if (err.response) {
      console.error("❌ Response status:", err.response.status);
      console.error("❌ Response data:", err.response.data);
    }
    message.error("Failed to load dashboard");
    return {};
  }
};

// src/Api/CoreApi.jsx - Add these functions at the bottom of the file

// ============================================
// SHORTLIST APIs (NEW)
// ============================================

/**
 * Get all shortlisted users for current user
 * @returns {Promise<Array>} List of shortlisted users
 */
// src/Api/CoreApi.jsx - Update getShortlist

export const getShortlist = async () => {
  try {
    const accessToken = localStorage.getItem("access_token");
    const response = await API.get("shortlist/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    console.log("✅ Shortlist Response:", response.data);
    return response.data || [];
  } catch (err) {
    console.error("❌ Error fetching shortlist:", err);
    return [];
  }
};

// src/Api/CoreApi.jsx - Fix addToShortlist

/**
 * Add user to shortlist
 * @param {string|number} targetUserId - User ID to shortlist
 * @returns {Promise<Object>} Response
 */
export const addToShortlist = async (targetUserId) => {
  try {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.error("❌ No access token found");
      message.error("Please login first");
      return {};
    }

    if (!targetUserId) {
      console.error("❌ No target user ID provided");
      message.error("Invalid user");
      return {};
    }

    const payload = {
      target_user_id: String(targetUserId)
    };

    console.log("📤 Sending payload:", payload);

    // ✅ FIX: Use shortlist/ (POST) - Django will route to AddShortlistView
    const response = await API.post(
      "shortlist/",  // ✅ CHANGE: "shortlist/add/" → "shortlist/"
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`,
        },
      }
    );

    console.log("✅ Success:", response.data);
    return response.data || {};
  } catch (error) {
    console.error("❌ Error adding to shortlist:", error);

    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);

      if (error.response.status === 400) {
        const msg = error.response.data?.message || error.response.data?.error || "";
        if (msg.includes("Already") || msg.includes("already")) {
          message.info("Already shortlisted");
          return { already_shortlisted: true };
        }
        message.error(msg || "Invalid request");
      } else if (error.response.status === 401) {
        message.error("Please login again");
      } else if (error.response.status === 404) {
        message.error("Endpoint not found");
      } else {
        message.error(error.response.data?.error || "Failed to shortlist user");
      }
    } else {
      message.error("Network error, please try again");
    }
    return {};
  }
};

/**
 * Remove user from shortlist
 * @param {string|number} shortlistId - Shortlist ID
 * @returns {Promise<Object>} Response
 */
export const removeFromShortlist = async (shortlistId) => {
  try {

    const accessToken = localStorage.getItem("access_token");
    const response = await API.delete(`shortlist-data/${shortlistId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    message.success("Removed from shortlist");
    return response.data || {};
  } catch (err) {
    console.error("Error removing from shortlist:", err);
    message.error("Failed to remove");
    return {};
  }
};

// ============================================
// INTEREST APIs (NEW)
// ============================================

/**
 * Get all sent interests
 * @returns {Promise<Array>} List of sent interests
 */
export const getInterests = async () => {
  try {
    const accessToken = localStorage.getItem("access_token");
    const response = await API.get("interest/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data || [];
  } catch (err) {
    console.error("Error fetching interests:", err);
    return [];
  }
};

// src/Api/CoreApi.jsx - Fix these functions

// ============================================
// SEND INTEREST - FIXED
// ============================================

// src/Api/CoreApi.jsx - Fix sendInterest

/**
 * Send Interest to User (Connection Request)
 * @param {string|number} userId - Target user ID
 * @param {string} msg - Optional message
 * @returns {Promise<Object>} Response
 */
export const sendInterest = async (userId, msg = "I'm interested in connecting with you!") => {
  try {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      message.error("Please login first");
      return {};
    }
    if (!userId) {
      message.error("Invalid user");
      return {};
    }

    const response = await API.post(
      "interest/",
      { to_user: userId, message: msg },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data || {};

  } catch (err) {
    console.error("❌ Error sending interest:", err);

    // ✅ Profile locked error handle karo
    if (err.response?.status === 403) {
      const errCode = err.response?.data?.code;
      if (errCode === 'PROFILE_NOT_UNLOCKED') {
        message.warning({
          content: '🔒 Please unlock this profile first to send interest.',
          duration: 4,
        });
      } else {
        message.error("You are not authorized");
      }
    } else if (err.response?.status === 400) {
      message.error("Interest already sent");
    } else if (err.response?.status === 401) {
      message.error("Please login again");
    } else {
      message.error("Failed to send interest");
    }
    return {};
  }
};


// src/Api/CoreApi.jsx - ADD THIS FUNCTION

export const UserDataGetById = async (userId) => {
  try {
    const accessToken = localStorage.getItem("access_token");
    const response = await API.get(`UserData/${userId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    console.log("✅ UserData fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching UserData:", error);
    throw error;
  }
};

// src/Api/CoreApi.jsx - ADD THESE FUNCTIONS AT THE BOTTOM

// ============================================================
// NOTIFICATION APIs
// ============================================================

/**
 * Get All Notifications for Current User
 * @param {number} limit - Number of notifications to fetch (default: 20)
 * @returns {Promise<Object>} { notifications, unread_count, total }
 */
export const getNotifications = async (limit = 20) => {
  try {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.error("❌ No access token found");
      return { notifications: [], unread_count: 0, total: 0 };
    }

    console.log("📥 Fetching notifications...");

    const response = await API.get(`notifications/?limit=${limit}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    console.log("📦 Notifications Response:", response.data);

    return response.data || { notifications: [], unread_count: 0, total: 0 };

  } catch (error) {
    console.error("❌ Error fetching notifications:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
    }
    return { notifications: [], unread_count: 0, total: 0 };
  }
};

// ============================================================
// MARK NOTIFICATION AS READ
// ============================================================

/**
 * Mark a single notification as read
 * @param {string} notificationId - Notification ID
 * @returns {Promise<Object>} Response
 */
export const markNotificationRead = async (notificationId) => {
  try {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.error("❌ No access token found");
      return null;
    }

    console.log(`📌 Marking notification ${notificationId} as read...`);

    const response = await API.post(
      `notifications/mark-read/${notificationId}/`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    console.log("✅ Mark read response:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Error marking notification as read:", error);
    return null;
  }
};

// ============================================================
// MARK ALL NOTIFICATIONS AS READ
// ============================================================

/**
 * Mark all notifications as read
 * @returns {Promise<Object>} Response
 */
export const markAllNotificationsRead = async () => {
  try {

    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      console.error("❌ No access token found");
      return null;
    }

    console.log("📌 Marking all notifications as read...");

    const response = await API.post(
      "notifications/mark-read/",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    console.log("✅ Mark all read response:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Error marking all as read:", error);
    return null;
  }
};

// ============================================================
// DELETE NOTIFICATION
// ============================================================

/**
 * Delete a notification
 * @param {string} notificationId - Notification ID
 * @returns {Promise<Object>} Response
 */
export const deleteNotification = async (notificationId) => {
  try {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.error("❌ No access token found");
      return null;
    }

    console.log(`🗑️ Deleting notification ${notificationId}...`);

    const response = await API.delete(
      `notifications/${notificationId}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    console.log("✅ Delete response:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Error deleting notification:", error);
    return null;
  }
};

// ============================================================
// GET UNREAD NOTIFICATION COUNT (OPTIONAL)
// ============================================================

/**
 * Get unread notification count
 * @returns {Promise<number>} Unread count
 */
export const getUnreadNotificationCount = async () => {
  try {
    const data = await getNotifications(1);
    return data.unread_count || 0;
  } catch (error) {
    console.error("❌ Error getting unread count:", error);
    return 0;
  }
};

// ============================================================
// NOTIFICATION POLLING (REAL-TIME UPDATES)
// ============================================================

/**
 * Start polling for new notifications
 * @param {Function} callback - Callback function with notification data
 * @param {number} interval - Polling interval in ms (default: 30000)
 * @returns {number} Interval ID
 */
export const startNotificationPolling = (callback, interval = 30000) => {
  console.log(`🔄 Starting notification polling (every ${interval / 1000}s)`);

  const pollInterval = setInterval(async () => {
    try {
      const data = await getNotifications(20);
      if (data && data.notifications) {
        callback(data);
      }
    } catch (error) {
      console.error("❌ Polling error:", error);
    }
  }, interval);

  return pollInterval;
};

// ============================================================
// STOP NOTIFICATION POLLING
// ============================================================

/**
 * Stop notification polling
 * @param {number} intervalId - Interval ID from startNotificationPolling
 */
export const stopNotificationPolling = (intervalId) => {
  if (intervalId) {
    clearInterval(intervalId);
    console.log("🔄 Notification polling stopped");
  }
};


export const sendLoginOTP = async (contact) => {
  try {
    const response = await API.post(
      "send-login-otp/",   // ← NEW endpoint
      { contact },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("📤 Login OTP Sent:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Login OTP Error:", error.response?.data);

    const errorMsg =
      error.response?.data?.error ||
      "Failed to send OTP. Please try again.";

    throw new Error(errorMsg);
  }
};


// ✅ LOGIN OTP Verify (ALAG endpoint)
export const verifyOTPAndLogin = async (contact, otp) => {
  try {
    const response = await API.post(
      "verify-login-otp/",   // ← NEW endpoint
      { contact, otp },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("📥 Login OTP Verify Response:", response.data);

    // ✅ LocalStorage me save karo
    if (response.data) {
      const { token, user_id, username, role, refer, gender } = response.data;

      if (token) {
        localStorage.setItem("access_token", token.access);
        localStorage.setItem("refresh_token", token.refresh);
        accessToken = token.access; 
      }
      if (user_id) localStorage.setItem("user_id", user_id);
      if (username) localStorage.setItem("username", username);
      if (role) localStorage.setItem("role", role);
      if (refer) localStorage.setItem("ref", refer);
      if (gender) localStorage.setItem("user_gender", gender);
    }

    return response.data;

  } catch (error) {
    console.error("❌ Login OTP Verify Error:", error.response?.data);

    const errorMsg =
      error.response?.data?.error ||
      "Invalid OTP. Please try again.";

    throw new Error(errorMsg);
  }
};

/**
 * Get User's Profile ID
 * @param {string} userId - User ID
 * @returns {Promise<string>} Profile ID (e.g., CR000001)
 */
export const getUserProfileId = async (userId) => {
  try {


    if (!accessToken || !userId) {
      console.warn("⚠️ No token or userId found");
      return null;
    }

    console.log("🔍 Fetching profile ID for user:", userId);

    // ✅ Try UserData endpoint
    const response = await API.get(`UserData/${userId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("📦 UserData Response:", response.data);

    let profileId = null;

    if (response.data) {
      // ✅ Check multiple locations for profile_id
      if (response.data.profile_id) {
        profileId = response.data.profile_id;
      } else if (response.data.user && response.data.user.profile_id) {
        profileId = response.data.user.profile_id;
      } else if (response.data.data && response.data.data.profile_id) {
        profileId = response.data.data.profile_id;
      }
    }

    console.log("📛 Profile ID found:", profileId);

    // ✅ Return formatted ID
    return profileId ? `CR${profileId}` : null;

  } catch (error) {
    console.error("❌ Error fetching profile ID:", error);
    return null;
  }
};

// ✅ Update UserDataGetwt to include profile_id



export const getDistrictsByState = async (stateName) => {
  if (!stateName) return [];

  try {

    const allStates = await User_StateGet();
    const state = allStates.find(s => s.state === stateName || s.state?.toLowerCase() === stateName?.toLowerCase());

    if (state && state.iso2) {
      const cities = await fetchExternalCities('IN', state.iso2);
      if (cities && cities.length > 0) {
        console.log(`✅ Loaded ${cities.length} cities from external API for ${stateName}`);
        return cities.map(c => c.name);
      }
    }
  } catch (error) {
    console.warn('⚠️ External cities API failed:', error.message);
  }
  try {
    const response = await axios.get(`${API_URL}/state/?state=${encodeURIComponent(stateName)}`);
    return response.data.districts || [];
  } catch (error) {
    console.error('❌ Failed to load districts:', error);
    return [];
  }
};

// ✅ Get cities by district name
export const getCitiesByDistrict = async (districtName) => {
  if (!districtName) return [];

  try {
    const response = await axios.get(`${API_URL}/district/${encodeURIComponent(districtName)}/cities/`);
    return response.data.cities || [];
  } catch (error) {
    console.warn('⚠️ Local cities API failed:', error.message);
    return [];
  }
};

export const getCastesByReligion = async (religion) => {
  try {
    console.log("📤 Fetching castes for religion:", religion);
    const response = await API.get(`caste/by-religion/?religion=${encodeURIComponent(religion)}`);
    console.log("📦 Castes Response:", response.data);
    return response.data || [];
  } catch (error) {
    console.error("❌ Error fetching castes:", error);
    return { castes: [] };
  }
};

// ✅ Get all states with districts (combined)
export const getAllStatesWithDistricts = async () => {
  try {
    const response = await API.get("state-districts/");
    console.log("📦 States with Districts:", response.data);
    return response.data || [];
  } catch (error) {
    console.error("❌ Error fetching states with districts:", error);
    return [];
  }
};



// ============================================
// PREMIUM PLANS API
// ============================================

/**
 * Get all premium plans
 * @returns {Promise<Array>} List of premium plans
 */
export const getPremiumPlans = async () => {
  try {
    const token = localStorage.getItem('access_token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await API.get('premium-plans/', { headers });
    return response.data || [];
  } catch (error) {
    console.error('❌ Error fetching premium plans:', error);
    return [];
  }
};

/**
 * Get single premium plan by ID
 * @param {string} planId - Plan ID
 * @returns {Promise<Object>} Plan data
 */
export const getPremiumPlanById = async (planId) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.get(`premium-plans/${planId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data || null;
  } catch (error) {
    console.error('❌ Error fetching premium plan:', error);
    return null;
  }
};

/**
 * Create new premium plan
 * @param {Object} data - Plan data
 * @returns {Promise<Object>} Created plan
 */
export const createPremiumPlan = async (data) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post('premium-plans/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('❌ Error creating premium plan:', error);
    throw error;
  }
};

/**
 * Update premium plan
 * @param {string} planId - Plan ID
 * @param {Object} data - Updated plan data
 * @returns {Promise<Object>} Updated plan
 */
export const updatePremiumPlan = async (planId, data) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.put(`premium-plans/${planId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('❌ Error updating premium plan:', error);
    throw error;
  }
};

/**
 * Delete premium plan
 * @param {string} planId - Plan ID
 * @returns {Promise<Object>} Response
 */
export const deletePremiumPlan = async (planId) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.delete(`premium-plans/${planId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('❌ Error deleting premium plan:', error);
    throw error;
  }
};

// ============================================================
// RECHARGE STATS API
// ============================================================

/**
 * Get Recharge Statistics for Dashboard
 * @returns {Promise<Object>} { totalPlans, totalAmount, activePlans, expiredPlans }
 */
export const getRechargeStats = async () => {
  try {


    if (!accessToken) {
      console.warn("⚠️ No access token found");
      return { totalPlans: 0, totalAmount: 0, activePlans: 0, expiredPlans: 0 };
    }

    const response = await API.get("api/recharge/stats/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    console.log("📦 Recharge Stats:", response.data);
    return response.data || { totalPlans: 0, totalAmount: 0, activePlans: 0, expiredPlans: 0 };

  } catch (error) {
    console.error("❌ Error fetching recharge stats:", error);
    return { totalPlans: 0, totalAmount: 0, activePlans: 0, expiredPlans: 0 };
  }
};
// ============================================
// PROMOTIONS API
// ============================================

// Get all promotions
export const PromotionsGet = async () => {
  try {
    // ✅ Public endpoint - no auth token needed
    const response = await axios.get(`${API_URL}/promotions/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("✅ Promotions fetched:", response.data);
    return response.data || [];
  } catch (err) {
    console.error("❌ Get promotions failed:", err);
    return [];
  }
};

// Create promotion
export const PromotionsPost = async (values) => {
  try {


    let formData = values;
    if (!(values instanceof FormData)) {
      formData = new FormData();
      Object.keys(values).forEach(key => {
        if (values[key] !== null && values[key] !== undefined) {
          formData.append(key, values[key]);
        }
      });
    }

    console.log("📤 Sending promotion data:");
    for (let pair of formData.entries()) {
      const value = pair[1] instanceof File ? `[FILE: ${pair[1].name}]` : pair[1];
      console.log(`  ${pair[0]}: ${value}`);
    }

    const response = await API.post("promotions/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("✅ Promotion created:", response.data);
    return response.data;

  } catch (err) {
    console.error("❌ Create promotion failed:", err);
    if (err.response) {
      console.error("❌ Status:", err.response.status);
      console.error("❌ Data:", err.response.data);
    }
    throw err;
  }
};
// Update promotion
export const PromotionsUpdate = async (id, values) => {
  try {
    const response = await API.put(`promotions/${id}/`, values, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    console.log("✅ Promotion updated:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Update promotion failed:", err);
    throw err;
  }
};

// Delete promotion
export const PromotionsRemove = async (id) => {
  try {
    const response = await API.delete(`promotions/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    console.log("✅ Promotion deleted:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Delete promotion failed:", err);
    throw err;
  }
};

// Track promotion view/click
export const TrackPromotion = async (id, type) => {
  try {
    const response = await API.post(`promotions/${id}/track/`, { type }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (err) {
    console.error("❌ Track failed:", err);
  }
};

export const checkUsernameAvailability = async (username) => {
  try {
    const response = await axios.get(`${API_URL}/api/check-username/${username}/`);
    return response.data;
  } catch (error) {
    console.error('Username check error:', error);
    throw error;
  }
};

/**
 * Get all premium members (users with active memberships)
 * @returns {Promise<Array>} List of premium members
 */
export const getPremiumMembers = async () => {
  try {
    const token = localStorage.getItem('access_token');

    if (!token) {
      console.warn("⚠️ No access token found");
      return [];
    }

    const response = await API.get('premium-members/', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    console.log("✅ Premium Members fetched:", response.data);
    return response.data || [];
  } catch (error) {
    console.error("❌ Error fetching premium members:", error);
    if (error.response?.status === 403) {
      message.error("You don't have permission to view premium members");
    } else {
      message.error("Failed to fetch premium members");
    }
    return [];
  }
};


// ============================================
// ✅ ADMIN GRANT PREMIUM - FIXED URLs
// ============================================

/**
 * Admin grants premium to a user manually
 */
export const grantPremiumToUser = async (data) => {
  try {
    const token = localStorage.getItem('access_token');
    console.log("📤 Grant Premium Data:", data);

    const response = await API.post('api/admin/grant-premium/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("✅ Premium granted:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Grant premium error:", error.response?.data || error.message);
    throw error;
  }
};

/**
 * Admin extends premium for existing user
 */
export const extendPremiumForUser = async (userId, data) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post(`api/admin/extend-premium/${userId}/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("❌ Extend premium error:", error.response?.data || error.message);
    throw error;
  }
};

/**
 * Admin removes premium from a user
 */
export const removePremiumFromUser = async (userId, reason = "") => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post(`api/admin/remove-premium/${userId}/`,
      { reason },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Remove premium error:", error.response?.data || error.message);
    throw error;
  }
};

/**
 * Get premium grant history
 */
export const getPremiumGrantHistory = async () => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.get('api/admin/premium-grant-history/', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data || [];
  } catch (error) {
    console.error("❌ Grant history error:", error.response?.data || error.message);
    return [];
  }
};

/**
 * Send SMS notification
 */
export const sendPremiumSMS = async (userId, planName) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post('api/send-premium-sms/',
      { user_id: userId, plan_name: planName },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.warn("⚠️ SMS send failed:", error.response?.data || error.message);
    return null;
  }
};

/**
 * Create in-app notification
 */
export const createUserNotification = async (data) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post('api/user-notifications/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.warn("⚠️ Notification failed:", error.response?.data || error.message);
    return null;
  }
};

/**
 * Get user's bank details from User model
 */
// export const getUserBankDetails = async () => {
//   try {
//     
//     const user_id = localStorage.getItem("user_id");

//     if (!user_id) {
//       console.warn("⚠️ No user_id found");
//       return { bank_account: '', ifsc_code: '', upi_id: '', bank_updated_at: null };
//     }

//     console.log("📤 Fetching bank details for user:", user_id);

//     // ✅ Try multiple endpoints
//     let bankData = { bank_account: '', ifsc_code: '', upi_id: '', bank_updated_at: null };

//     // METHOD 1: Try api/user/profile endpoint (best)
//     try {
//       const response = await API.get(`api/user/profile/${user_id}/`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`
//         }
//       });

//       console.log("📦 Profile response:", response.data);

//       if (response.data) {
//         bankData = {
//           bank_account: response.data.bank_account || '',
//           ifsc_code: response.data.ifsc_code || '',
//           upi_id: response.data.upi_id || '',
//           bank_updated_at: response.data.bank_updated_at || null,
//         };

//         // ✅ If we got data, return it
//         if (bankData.bank_account || bankData.ifsc_code || bankData.upi_id) {
//           return bankData;
//         }
//       }
//     } catch (err) {
//       console.warn("⚠️ Profile endpoint failed:", err.response?.status);
//     }

//     // METHOD 2: Try UserData endpoint
//     try {
//       const response = await API.get(`UserData/${user_id}`, {  // ← NO trailing slash
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`
//         }
//       });

//       console.log("📦 UserData response:", response.data);

//       if (response.data) {
//         bankData = {
//           bank_account: response.data.bank_account || '',
//           ifsc_code: response.data.ifsc_code || '',
//           upi_id: response.data.upi_id || '',
//           bank_updated_at: response.data.bank_updated_at || null,
//         };
//         return bankData;
//       }
//     } catch (err) {
//       console.warn("⚠️ UserData endpoint failed:", err.response?.status);
//     }

//     // METHOD 3: Try UserRegister endpoint
//     try {
//       const response = await API.get(`UserRegister/${user_id}`, {  // ← NO trailing slash
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`
//         }
//       });

//       console.log("📦 UserRegister response:", response.data);

//       if (response.data) {
//         bankData = {
//           bank_account: response.data.bank_account || '',
//           ifsc_code: response.data.ifsc_code || '',
//           upi_id: response.data.upi_id || '',
//           bank_updated_at: response.data.bank_updated_at || null,
//         };
//         return bankData;
//       }
//     } catch (err) {
//       console.warn("⚠️ UserRegister endpoint failed:", err.response?.status);
//     }

//     return bankData;

//   } catch (error) {
//     console.error("❌ getUserBankDetails Error:", error);
//     return { bank_account: '', ifsc_code: '', upi_id: '', bank_updated_at: null };
//   }
// };

// /**
//  * Update user's bank details
//  * @param {Object} data - { bank_account, ifsc_code, upi_id }
//  */
// export const updateBankDetails = async (data) => {
//   try {
//     
//     const user_id = localStorage.getItem("user_id");

//     if (!user_id) {
//       throw new Error("User ID not found");
//     }

//     console.log("📤 Updating bank details for user:", user_id);
//     console.log("📤 Data:", data);

//     // ✅ Clean data
//     const cleanData = {};
//     if (data.bank_account && data.bank_account.trim()) {
//       cleanData.bank_account = data.bank_account.trim();
//     }
//     if (data.ifsc_code && data.ifsc_code.trim()) {
//       cleanData.ifsc_code = data.ifsc_code.trim().toUpperCase();
//     }
//     if (data.upi_id && data.upi_id.trim()) {
//       cleanData.upi_id = data.upi_id.trim();
//     }
//     cleanData.bank_updated_at = new Date().toISOString();

//     console.log("📤 Clean data:", cleanData);

//     // ✅ Try api/user/profile endpoint first
//     try {
//       const response = await API.put(
//         `api/user/profile/${user_id}`,  // ← NO trailing slash
//         cleanData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`
//           }
//         }
//       );

//       console.log("✅ Bank details updated via Profile:", response.data);
//       message.success("✅ Bank details updated successfully!");
//       return response.data;

//     } catch (err) {
//       console.warn("⚠️ Profile update failed:", err.response?.status);

//       // If 404, try UserRegister
//       if (err.response?.status === 404) {
//         try {
//           const response = await API.put(
//             `UserRegister/${user_id}`,  // ← NO trailing slash
//             cleanData,
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${accessToken}`
//               }
//             }
//           );

//           console.log("✅ Bank details updated via UserRegister:", response.data);
//           message.success("✅ Bank details updated successfully!");
//           return response.data;

//         } catch (err2) {
//           console.warn("⚠️ UserRegister update failed:", err2.response?.status);
//         }
//       }

//       // Try UserData
//       try {
//         const response = await API.put(
//           `UserData/${user_id}`,  // ← NO trailing slash
//           cleanData,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${accessToken}`
//             }
//           }
//         );

//         console.log("✅ Bank details updated via UserData:", response.data);
//         message.success("✅ Bank details updated successfully!");
//         return response.data;

//       } catch (err3) {
//         console.warn("⚠️ UserData update failed:", err3.response?.status);
//       }

//       throw err;
//     }

//   } catch (error) {
//     console.error("❌ updateBankDetails Error:", error);
//     const errorMsg = error?.response?.data?.error || 
//                     error?.response?.data?.message || 
//                     error?.message || 
//                     "Failed to update bank details";
//     message.error(errorMsg);
//     throw error;
//   }
// };


/**
 * Get Developer Dashboard Data
 */
export const getDeveloperDashboard = async () => {
  try {

    const response = await API.get("api/developer/dashboard/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("❌ getDeveloperDashboard Error:", err);
    // Fallback - DevTransactions se data banao
    try {

      const txRes = await API.get("DevTransactions/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const transactions = Array.isArray(txRes.data) ? txRes.data : [];

      // Credits
      const totalEarnings = transactions
        .filter(t => t.type === "credit")
        .reduce((s, t) => s + (parseFloat(t.amount) || 0), 0);

      // Completed withdrawals
      const totalWithdrawn = transactions
        .filter(t =>
          (t.type === "withdrawal" || t.type === "debit") &&
          (t.status === "completed" || t.status === "approved")
        )
        .reduce((s, t) => s + (parseFloat(t.amount) || 0), 0);

      // Pending withdrawals
      const pendingWithdrawal = transactions
        .filter(t =>
          (t.type === "withdrawal" || t.type === "debit") &&
          t.status === "pending"
        )
        .reduce((s, t) => s + (parseFloat(t.amount) || 0), 0);

      // Available balance
      const availableBalance = totalEarnings - totalWithdrawn - pendingWithdrawal;

      // Recent withdrawals
      const recentWithdrawals = transactions
        .filter(t => t.type === "withdrawal" || t.type === "debit")
        .sort((a, b) =>
          new Date(b.created_date || 0) - new Date(a.created_date || 0)
        )
        .map(t => ({
          ...t,
          date: t.created_date || t.date,
        }));

      // Stats
      const withdrawalTx = transactions.filter(
        t => t.type === "withdrawal" || t.type === "debit"
      );

      return {
        earnings: {
          total_earnings: totalEarnings,
          available_balance: availableBalance > 0 ? availableBalance : 0,
          total_withdrawn: totalWithdrawn,
          pending_withdrawal: pendingWithdrawal,
        },
        stats: {
          total_requests: withdrawalTx.length,
          pending: withdrawalTx.filter(t => t.status === "pending").length,
          completed: withdrawalTx.filter(
            t => t.status === "completed" || t.status === "approved"
          ).length,
          rejected: withdrawalTx.filter(t => t.status === "rejected").length,
        },
        recent_withdrawals: recentWithdrawals,
        bank_details: {
          has_bank_details: false,
          has_upi: false,
          bank_account: null,
          ifsc_code: null,
          upi_id: null,
        },
      };
    } catch (fallbackErr) {
      console.error("❌ Fallback also failed:", fallbackErr);
      return {
        earnings: {
          total_earnings: 0,
          available_balance: 0,
          total_withdrawn: 0,
          pending_withdrawal: 0,
        },
        stats: {
          total_requests: 0,
          pending: 0,
          completed: 0,
          rejected: 0,
        },
        recent_withdrawals: [],
        bank_details: {
          has_bank_details: false,
          has_upi: false,
        },
      };
    }
    return null;
  }
};

// ============================================
// ✅ WITHDRAW REQUESTS
// ============================================

/**
 * Get user's withdraw requests
 */

export const getWithdrawRequests = async () => {
  try {
    // ✅ Fresh token lo


    // ✅ Token check
    if (!accessToken) {
      console.error("❌ No access token found");
      return [];
    }

    const response = await API.get("withdraw/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response.data || [];
  } catch (error) {
    console.error("❌ getWithdrawRequests Error:", error);

    // ✅ 401 specifically handle karo
    if (error?.response?.status === 401) {
      console.error("❌ Token expired or invalid - please login again");
      // Optional: redirect to login
      // localStorage.removeItem('access_token');
      // window.location.href = '/login';
    }

    return [];
  }
};

/**
 * Get Developer Bank Details
 */
export const getDeveloperBankDetails = async () => {
  try {


    const response = await API.get("api/developer/bank-details/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data || null;
  } catch (error) {
    console.error("❌ getDeveloperBankDetails Error:", error);
    return null;
  }
};


/**
 * Create withdraw request
 * @param {Object} data - { amount, bank_account, ifsc_code, upi_id }
 */
export const createWithdrawRequest = async (data) => {
  try {

    const response = await API.post("withdraw/", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("❌ createWithdrawRequest Error:", error);
    throw error;
  }
};

// ============================================
// ✅ REFERRAL STATS
// ============================================


export const getUserReferralStats = async () => {
  try {

    const response = await API.get("user/referral-stats/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data || {
      referred_count: 0,
      referred_users: [],
      total_commission: 0,
      available_balance: 0,
      pending_withdrawals: 0,
      total_withdrawn: 0,
      staff_transactions: []
    };
  } catch (error) {
    console.error("❌ getUserReferralStats Error:", error);
    return {
      referred_count: 0,
      referred_users: [],
      total_commission: 0,
      available_balance: 0,
      pending_withdrawals: 0,
      total_withdrawn: 0,
      staff_transactions: []
    };
  }
};

/**
 * Update Developer Bank Details
 */
export const updateDeveloperBankDetails = async (data) => {
  try {


    console.log("📤 Updating bank details:", data);

    const response = await API.put(
      "api/developer/bank-details/",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    console.log("✅ Bank Details Updated:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Update Bank Error:", error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error("Failed to update bank details");
  }
};

/**
 * Submit Developer Withdrawal Request
 */
export const submitDeveloperWithdrawal = async (values) => {
  try {


    console.log("📤 Submitting withdrawal:", values);

    // ✅ Sahi endpoint use karo
    const response = await API.post(
      "api/developer/withdrawal-request/",
      values,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    console.log("✅ Withdrawal submitted:", response.data);
    return response.data;

  } catch (err) {
    console.error("❌ submitDeveloperWithdrawal Error:", err?.response?.data);

    if (err.response?.status === 400) {
      const errData = err.response.data;
      if (errData?.error) {
        throw new Error(errData.error);
      }
      if (errData?.bank_details || errData?.upi) {
        throw new Error("Please add bank details or UPI ID first");
      }
    }

    throw new Error(
      err.response?.data?.error ||
      err.response?.data?.message ||
      err.message ||
      "Withdrawal submission failed"
    );
  }
};
// ============================================
// PLAN PURCHASE - Commission Auto Distribute
// ============================================
// export const processPlanPurchaseCommission = async ({
//   planId,
//   planName,
//   planPrice,
//   userId,
//   addedByStaffId = null,
// }) => {
//   try {

//     const timestamp = new Date().toISOString();
//     const refId = `PLN-${Date.now()}`;
//     const isStaffAdded = !!addedByStaffId;

//     // Commission amounts
//     const devAmount = Math.round(planPrice * 15 / 100);
//     const staffAmount = isStaffAdded
//       ? Math.round(planPrice * 15 / 100)
//       : 0;
//     const adminAmount = planPrice - devAmount - staffAmount;

//     console.log("💰 Commission:", {
//       planPrice, devAmount,
//       staffAmount, adminAmount, isStaffAdded
//     });

//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${accessToken}`,
//     };

//     // ============ 1. USER TRANSACTION ============
//     await API.post("UserTransactions/", {
//       user_id: userId,
//       amount: planPrice,
//       type: "debit",
//       status: "completed",
//       description: `Plan: ${planName}`,
//       plan_id: planId,
//       plan_name: planName,
//       ref_id: refId,
//       created_date: timestamp,
//     }, { headers });

//     // ============ 2. DEVELOPER COMMISSION ============
//     await API.post("DevTransactions/", {
//       amount: devAmount,
//       type: "credit",
//       status: "completed",
//       description: `Commission: ${planName} | User: ${userId}`,
//       plan_id: planId,
//       plan_name: planName,
//       user_id: userId,
//       ref_id: refId,
//       created_date: timestamp,
//     }, { headers });

//     // Dev Total Revenue
//     try {
//       const devRevRes = await API.get("DevTotalRevenue/", { headers });
//       const devRevArr = Array.isArray(devRevRes.data) ? devRevRes.data : [];
//       const devRev = devRevArr[0];

//       if (devRev?.id) {
//         await API.put(`DevTotalRevenue/${devRev.id}/`, {
//           ...devRev,
//           total_amount: (parseFloat(devRev.total_amount) || 0) + devAmount,
//           total_commission: (parseFloat(devRev.total_commission) || 0) + devAmount,
//         }, { headers });
//       } else {
//         await API.post("DevTotalRevenue/", {
//           total_amount: devAmount,
//           total_commission: devAmount,
//         }, { headers });
//       }
//     } catch (e) {
//       console.warn("Dev revenue update failed:", e);
//     }

//     // ============ 3. STAFF COMMISSION ============
//     if (isStaffAdded && staffAmount > 0) {
//       await API.post("StaffTransactions/", {
//         staff_id: addedByStaffId,
//         amount: staffAmount,
//         type: "credit",
//         status: "completed",
//         description: `Commission: ${planName} | User: ${userId}`,
//         plan_id: planId,
//         plan_name: planName,
//         user_id: userId,
//         ref_id: refId,
//         created_date: timestamp,
//       }, { headers });

//       // Staff Total Revenue
//       try {
//         const staffRevRes = await API.get("StaffTotalRevenue/", { headers });
//         const staffRevArr = Array.isArray(staffRevRes.data) ? staffRevRes.data : [];
//         const staffRev = staffRevArr.find(
//           s => String(s.staff_id) === String(addedByStaffId)
//         );

//         if (staffRev?.id) {
//           await API.put(`StaffTotalRevenue/${staffRev.id}/`, {
//             ...staffRev,
//             total_amount: (parseFloat(staffRev.total_amount) || 0) + staffAmount,
//             total_commission: (parseFloat(staffRev.total_commission) || 0) + staffAmount,
//           }, { headers });
//         } else {
//           await API.post("StaffTotalRevenue/", {
//             staff_id: addedByStaffId,
//             total_amount: staffAmount,
//             total_commission: staffAmount,
//           }, { headers });
//         }
//       } catch (e) {
//         console.warn("Staff revenue update failed:", e);
//       }
//     }

//     // ============ 4. ADMIN COMMISSION ============
//     try {
//       const adminRevRes = await API.get("AdminTotalRevenue/", { headers });
//       const adminRevArr = Array.isArray(adminRevRes.data) ? adminRevRes.data : [];
//       const adminRev = adminRevArr[0];

//       if (adminRev?.id) {
//         await API.put(`AdminTotalRevenue/${adminRev.id}/`, {
//           ...adminRev,
//           total_amount: (parseFloat(adminRev.total_amount) || 0) + adminAmount,
//           total_commission: (parseFloat(adminRev.total_commission) || 0) + adminAmount,
//         }, { headers });
//       } else {
//         await API.post("AdminTotalRevenue/", {
//           total_amount: adminAmount,
//           total_commission: adminAmount,
//         }, { headers });
//       }
//     } catch (e) {
//       console.warn("Admin revenue update failed:", e);
//     }

//     console.log("✅ All commissions distributed!");
//     return { success: true, devAmount, staffAmount, adminAmount, refId };

//   } catch (error) {
//     console.error("❌ Commission error:", error);
//     throw error;
//   }
// };

// ============================================
// ✅ MY REFERRED USERS
// ============================================
export const getMyReferredUsers = async () => {
  try {


    if (!accessToken) {
      console.error("❌ No access token found");
      return { referred_users: [], total_count: 0, stats: {} };
    }

    console.log("📤 Fetching my referred users...");

    const response = await API.get("api/my-referred-users/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      }
    });

    console.log("✅ Referred users response:", response.data);
    return response.data || { referred_users: [], total_count: 0, stats: {} };

  } catch (error) {
    console.error("❌ getMyReferredUsers error:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
    }
    return { referred_users: [], total_count: 0, stats: {} };
  }
};


// ============================================================
// ✅ STAFF WITHDRAWAL API FUNCTIONS
// ============================================================

/**
 * Staff withdrawal request submit karo
 * @param {Object} data - { amount, payment_method }
 */
export const StaffWithdrawPost = async (data) => {
  try {


    if (!accessToken) {
      console.error("❌ No token found");
      throw new Error("Please login first");
    }

    const response = await API.post("api/staff/withdraw/", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    console.log("✅ Staff withdrawal response:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ StaffWithdrawPost Error:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
      throw new Error(error.response.data?.error || "Failed to submit withdrawal request");
    }
    throw error;
  }
};

/**
 * Get staff's withdrawal requests
 */
export const StaffWithdrawalsGet = async () => {
  try {


    if (!accessToken) {
      console.error("❌ No token found");
      return [];
    }

    const response = await API.get("api/staff/withdrawals/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    console.log("📦 Staff withdrawals:", response.data);
    return response.data || [];

  } catch (error) {
    console.error("❌ StaffWithdrawalsGet Error:", error);
    return [];
  }
};


// ============================================================
// ✅ ADMIN WITHDRAWAL API FUNCTIONS
// ============================================================

/**
 * Admin - Get all withdrawal requests
 * @param {Object} params - { status, user_type } filters
 * @returns {Promise<Array>} List of withdrawal requests
 */
export const AdminGetWithdrawals = async (params = {}) => {
  try {


    if (!accessToken) {
      console.error("❌ No token found");
      return [];
    }

    // Build query string
    const queryParams = new URLSearchParams();
    if (params.status && params.status !== 'all') queryParams.append('status', params.status);
    if (params.user_type && params.user_type !== 'all') queryParams.append('user_type', params.user_type);

    const url = `api/admin/withdrawals/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

    const response = await API.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    console.log("📦 Admin Withdrawals:", response.data);
    return response.data?.withdrawals || [];

  } catch (error) {
    console.error("❌ AdminGetWithdrawals Error:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
    }
    return [];
  }
};

/**
 * Admin - Update withdrawal request status
 * @param {number} withdrawalId - Withdrawal request ID
 * @param {string} status - New status (pending, approved, processing, completed, rejected)
 * @param {string} adminNote - Optional admin note
 * @returns {Promise<Object>} Response
 */
export const AdminUpdateWithdrawalStatus = async (withdrawalId, status, adminNote = '') => {
  try {


    if (!accessToken) {
      console.error("❌ No token found");
      throw new Error("Please login first");
    }

    const response = await API.put(
      `api/admin/withdrawals/${withdrawalId}/`,
      {
        status: status,
        admin_note: adminNote
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    console.log("✅ Withdrawal status updated:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ AdminUpdateWithdrawalStatus Error:", error);
    if (error.response) {
      console.error("❌ Status:", error.response.status);
      console.error("❌ Data:", error.response.data);
      throw new Error(error.response.data?.error || "Failed to update status");
    }
    throw error;
  }
};

/**
 * Admin - Delete withdrawal request
 * @param {number} withdrawalId - Withdrawal request ID
 * @returns {Promise<Object>} Response
 */
export const AdminDeleteWithdrawal = async (withdrawalId) => {
  try {


    if (!accessToken) {
      console.error("❌ No token found");
      throw new Error("Please login first");
    }

    const response = await API.delete(
      `api/admin/withdrawals/${withdrawalId}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    console.log("✅ Withdrawal deleted:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ AdminDeleteWithdrawal Error:", error);
    throw error;
  }
};

// ============================================
// ✅ USER BANK DETAILS
// ============================================
export const getUserBankDetails = async () => {
  try {

    const userId = localStorage.getItem("user_id");

    if (!accessToken || !userId) {

      return null;
    }

    console.log("🏦 Fetching bank details for user:", userId);

    const response = await API.get(`UserRegister/${userId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    console.log("✅ Bank details fetched:", response.data);

    return {
      bank_account: response.data?.bank_account || "",
      ifsc_code: response.data?.ifsc_code || "",
      upi_id: response.data?.upi_id || "",
      bank_updated_at: response.data?.bank_updated_at || null,
      username: response.data?.username || "",
      contact: response.data?.contact || "",
      user_id: response.data?.id || userId,
    };
  } catch (error) {
    console.error("❌ getUserBankDetails error:", error);
    return null;
  }
};

export const updateBankDetails = async (data) => {
  try {

    const userId = localStorage.getItem("user_id");

    if (!accessToken || !userId) {
      message.error("Please login first");
      return { success: false, message: "Not authenticated" };
    }

    console.log("🏦 Updating bank details for user:", userId);

    const payload = {
      bank_account: data.bank_account || "",
      ifsc_code: data.ifsc_code || "",
      upi_id: data.upi_id || "",
    };

    const response = await API.put(
      `UserRegister/${userId}/`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    console.log("✅ Bank details updated:", response.data);

    return {
      success: true,
      message: "Bank details updated successfully",
      data: response.data,
    };
  } catch (error) {
    console.error("❌ updateBankDetails error:", error);
    return {
      success: false,
      message: error.response?.data?.error || "Failed to update bank details",
    };
  }
};

// ============================================================
// ✅ RAZORPAY PAYMENT FUNCTIONS - ADD THESE
// ============================================================

/**
 * Create Razorpay Order
 * @param {Object} data - { planId, paymentMethod }
 * @returns {Promise<Object>} Order details
 */

// ✅ createRazorpayOrder - Fixed
export const createRazorpayOrder = async (orderData) => {
  try {
    const token = localStorage.getItem('access_token');
    const userId = localStorage.getItem('user_id');  // ✅ User ID लो
    const baseUrl = BASE_API;

    // ✅ user_id add करो payload में
    const payload = {
      ...orderData,
      user_id: userId,  // ✅ Backend को user_id मिलेगा
    };

    console.log("📤 Sending to create-order:", payload);

    const response = await axios.post(
      `${baseUrl}/api/create-order/`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("✅ Order created:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Order creation failed:", error.response?.data);
    return {
      success: false,
      error: error.response?.data?.error || "Order creation failed"
    };
  }
};

// ✅ verifyRazorpayPayment - Fixed
export const verifyRazorpayPayment = async (paymentData) => {
  try {
    const token = localStorage.getItem('access_token');

    // ✅ Add /api/ prefix
    const url = `${BASE_API}/api/verify-payment/`;
    console.log("🔍 Verify URL:", url);  // Debug log

    const response = await axios.post(
      url,
      paymentData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("✅ Verify result:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ URL Called:", error.config?.url);
    console.error("❌ Status:", error.response?.status);
    console.error("❌ Payment verification failed:", error.response?.data);
    return {
      success: false,
      error: error.response?.data?.error || "Verification failed"
    };
  }
};


// ============================================================
// ✅ REFERRAL CODE VALIDATION - ADD THIS
// ============================================================


export const validateReferralCode = async (referralCode) => {
  try {
    if (!referralCode || referralCode.trim().length === 0) {
      return { valid: false, message: 'Please enter a referral code' };
    }

    const cleanCode = referralCode.trim();
    console.log(`🔍 Validating: ${cleanCode}`);

    // ✅ No auth token - public endpoint
    // API interceptor me 'api/validate-referral/' already public hai
    const response = await API.post(
      'api/validate-referral/',
      {
        code: cleanCode,          // ✅ Primary key
        referral_code: cleanCode, // ✅ Backup key
      }
    );

    console.log('✅ Response:', response.data);
    return response.data;

  } catch (error) {
    console.error('❌ Validation error:', error.response?.status, error.response?.data);

    // ✅ 401 = Auth error - public endpoint set karo
    if (error.response?.status === 401) {
      console.error('🔑 Auth required - check PUBLIC_POST_ENDPOINTS in Api.js');
      return {
        valid: false,
        message: '⚠️ Server configuration error'
      };
    }

    return {
      valid: false,
      message: error.response?.data?.message || 'Error validating code'
    };
  }
};
// ============================================
// ✅ STAFF GRANT PREMIUM
// ============================================
export const staffGrantPremiumToUser = async (data) => {
  try {
    const token = localStorage.getItem('access_token');
    console.log("📤 Staff Grant Premium Data:", data);

    const response = await API.post('api/staff/grant-premium/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("✅ Staff Premium granted:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Staff Grant premium error:", error.response?.data || error.message);
    throw error;
  }
};


// ============================================
// ✅ STAFF PUBLIC REGISTRATION
// ============================================
export const staffPublicRegister = async (formData) => {
  try {
    const response = await API.post('api/staff/register/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Registration failed' };
  }
};

// ✅ STAFF APPROVE/REJECT (Admin)
export const staffApproveReject = async (userId, action, reason = '', deleteUser = false) => {
  try {
    const token = localStorage.getItem('access_token');
    const response = await API.post(`api/staff/approve/${userId}/`,
      { action, reason, delete: deleteUser },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Action failed' };
  }
};

// ============================================
// 💰 USER WALLET APIs
// ============================================

export const getUserWallet = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.get("api/wallet/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Wallet fetch error:", error);
    throw error;
  }
};

export const getWalletTransactions = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.get("api/wallet/transactions/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Transactions error:", error);
    throw error;
  }
};

export const buyPlanFromWallet = async (planId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.post(
      "api/wallet/buy-plan/",
      { plan_id: planId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Wallet purchase error:", error);
    throw error;
  }
};

// ============================================
// 👑 ADMIN WALLET APIs
// ============================================

// All wallets list
export const adminGetAllWallets = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.get("api/admin/wallet/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Admin wallets list error:", error);
    throw error;
  }
};

// Single user wallet + history
export const adminGetUserWallet = async (userId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.get(`api/admin/wallet/${userId}/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Admin get wallet error:", error);
    throw error;
  }
};

// Delete FULL wallet
export const adminDeleteWallet = async (userId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.delete(
      `api/admin/wallet/${userId}/?all=true`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Admin delete wallet error:", error);
    throw error;
  }
};

// Delete one transaction inside a user wallet
export const adminDeleteWalletTransaction = async (userId, transactionId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.delete(
      `api/admin/wallet/${userId}/?transaction_id=${transactionId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Admin delete transaction error:", error);
    throw error;
  }
};

// ============================================
// 🛒 ADMIN WALLET PURCHASES HISTORY
// ============================================

// List: only plans bought via wallet (users only)
export const adminGetWalletPurchases = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.get("api/admin/wallet-purchases/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Admin wallet purchases error:", error);
    throw error;
  }
};

// Delete ONE purchase row (by WalletTransaction id)
export const adminDeleteWalletPurchase = async (transactionId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await API.delete(
      `api/admin/wallet-purchases/?transaction_id=${transactionId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Admin delete wallet purchase error:", error);
    throw error;
  }
};